<template>
  <div id="activationCode">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>激活码管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 激活码列表卡片 -->
    <el-card class="box-card">
      <!-- 搜索表单 -->
      <el-form
        :inline="true"
        ref="queryForm"
        :model="queryMap"
        label-width="70px"
      >
        <el-form-item label="激活码">
          <el-input
            @keyup.enter.native="search"
            @clear="search"
            clearable
            v-model="queryMap.code"
            placeholder="请输入激活码关键词"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品标题">
          <el-input
            @keyup.enter.native="search"
            @clear="search"
            clearable
            v-model="queryMap.goodsTitle"
            placeholder="请输入商品标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="激活码状态">
          <el-select
            clearable
            @clear="search"
            v-model="queryMap.status"
            placeholder="请选择激活码状态"
          >
            <el-option label="未使用" value="UNUSED"></el-option>
            <el-option label="已使用" value="USED"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品类型">
          <el-select
            clearable
            @clear="search"
            v-model="queryMap.goodsType"
            placeholder="请选择商品类型"
          >
            <el-option label="单招" value="单招"></el-option>
            <el-option label="专升本" value="专升本"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="search" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="activationCodeList"
        border
        style="width: 100%"
        height="390"
      >
        <el-table-column
          label="ID"
          prop="id"
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="激活码"
          width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="goodsTitle"
          label="商品名称"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="goodsType"
          label="商品类型"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="success"
              v-if="scope.row.status === 'UNUSED'"
              >未使用</el-tag
            >
            <el-tag size="mini" type="info" v-else>已使用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="生成时间"
          width="160"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="userId"
          label="使用人ID"
          width="100"
          align="center"
          default="--"
        ></el-table-column>
        <el-table-column
          prop="usedAt"
          label="使用时间"
          width="160"
          align="center"
          default="--"
        ></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <!-- 操作按钮可以根据需要添加，例如查看详情等 -->
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="viewDetails(scope.row)"
              v-hasPermission="'activationCode:view'"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "ActivationCodeList",
  data() {
    return {
      loading: true,
      total: 0,
      activationCodeList: [],
      // 查询条件对象，与后端 ActivationCodeVO 对应
      queryMap: {
        pageNum: 1,
        pageSize: 20,
        code: "",
        goodsTitle: "",
        status: "",
        goodsType: "",
      },
    };
  },
  created() {
    // 组件创建时加载数据
    this.getActivationCodeList();
  },
  methods: {
    /**
     * 获取激活码列表数据
     */
    async getActivationCodeList() {
      this.loading = true;
      try {
        // 发起请求，注意这里的 URL 要与你后端 Controller 的映射一致
        const { data: res } = await this.$http.get("/activationCode/list", {
          params: this.queryMap,
        });
        if (res.code !== 200) {
          this.$message.error("获取激活码列表失败：" + res.msg);
          return;
        }
        // 赋值数据
        this.total = res.data.total;
        this.activationCodeList = res.data.rows;
      } catch (error) {
        this.$message.error("获取激活码列表异常：" + error.message);
      } finally {
        // 无论成功失败，都关闭加载状态
        this.loading = false;
      }
    },

    /**
     * 搜索按钮点击事件
     */
    search() {
      // 重置页码为1，然后重新加载数据
      this.queryMap.pageNum = 1;
      this.getActivationCodeList();
    },

    /**
     * 重置按钮点击事件
     */
    reset() {
      // 清空查询条件
      this.queryMap = {
        pageNum: 1,
        pageSize: this.queryMap.pageSize, // 保留页码大小
        code: "",
        goodsTitle: "",
        status: "",
        goodsType: "",
      };
      // 重新加载数据
      this.getActivationCodeList();
    },

    /**
     * 每页条数改变
     * @param {Number} newSize 新的每页条数
     */
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getActivationCodeList();
    },

    /**
     * 当前页改变
     * @param {Number} current 新的当前页码
     */
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getActivationCodeList();
    },

    /**
     * 查看详情（示例方法）
     * @param {Object} row 表格行数据
     */
    viewDetails(row) {
      this.$message.info(`查看激活码 ${row.code} 的详情`);
      // 这里可以打开一个弹窗来显示更详细的信息
    },
  },
};
</script>

<style scoped>
/* 可以添加一些组件专属的样式 */
</style>
